var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GetWechatUserInfo } from "./wechat";
import { config } from "../config/constants";
import { isWeixin } from "../utils/userAgent";
import { pageview } from "./common";
import { concatURI } from "../utils/common";
import { getUtm } from "../utils/preflight";
/**
 * 获取jsconfig
 * @description 获取网页授权的配置，详见：{@link https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html}
 */
export function initJsConfig(jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'hideMenuItems', 'hideAllNonBaseMenuItem'], menuList, { debug = false } = {}) {
    if (!isWeixin())
        return;
    window.cw('ajax', 'jsconfig?url=' + encodeURIComponent(window.location.href.split(/[#]/)[0]), (code) => __awaiter(this, void 0, void 0, function* () {
        wx.config({
            debug,
            appId: code.appid,
            nonceStr: code.nonceStr,
            signature: code.signature,
            timestamp: code.timestamp,
            jsApiList,
        });
        if (menuList) {
            wx.ready(() => {
                if (menuList.length) {
                    wx.hideMenuItems({ menuList });
                }
                else {
                    wx.hideAllNonBaseMenuItem();
                }
            });
        }
    }));
}
/**
 * 更新分享卡片
 * @description 在授权后调用，用于更新在转发或分享时的卡片内容
 */
export function updateWxShareData(shareInfo) {
    if (!(isWeixin() && (shareInfo === null || shareInfo === void 0 ? void 0 : shareInfo.title)))
        return;
    wx.ready(() => __awaiter(this, void 0, void 0, function* () {
        const { openid } = yield GetWechatUserInfo();
        const { title, desc, link = concatURI(window.location.href, Object.assign({ originOpenId: openid }, getUtm() || {})), imgUrl = config.logo } = shareInfo;
        wx.updateAppMessageShareData({
            title,
            desc,
            link,
            imgUrl, /**分享图标*/
        });
        wx.updateTimelineShareData({
            title,
            link,
            imgUrl, /**分享图标*/
        });
    }));
}
/**
 * 微信相关的更新和页面追踪
 * @description 会调用`updateWxShareData`更新分享信息，并记录pageview
 */
export function setBaseInfo(pageInfo) {
    return __awaiter(this, void 0, void 0, function* () {
        /**分享信息*/
        updateWxShareData(pageInfo.shareInfo);
        const { title, productBu, params } = pageInfo;
        try {
            const info = yield GetWechatUserInfo();
            const { appId, uaId } = config;
            window.ca('set', 'appid', appId);
            window.ca('set', 'openid', info.openid);
            window.ca('set', 'nickname', info.nickname);
            const page = Object.assign({ title, path: window.location.href, uaId, cms: pageInfo.cms, tagIds: pageInfo.tagIds, productBu }, params);
            pageview(page);
        }
        catch (_a) {
            window.ca('set', 'cms', pageInfo.cms);
            window.ca('set', 'tag', pageInfo.tagIds);
            window.ca('send', 'pageview', { title });
        }
    });
}
